import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import Layout from "./layout.tsx";
import Login from "../Pages/Login/Login.tsx";
import { FillDetails } from "../Pages/FillDetails/FillDetails.tsx";
import Orders from "../Pages/Orders/Orders.tsx";
//import RaiseInvoice from "../Pages/RaiseInvoice/RaiseInvoiceDetailed.tsx";
// import RaiseInvoice from "../Pages/RaiseInvoice/RaiseInvoiceDetailed.tsx";
import Analytics from "../Pages/Analytics/Analytics.tsx";
import Profile from "../Pages/Profile&Settings/Profile.tsx";
import SubscriptionDetailsPage from "../Pages/SubscriptionDetails/SubscriptionDetailsPage.tsx";
import ChequeredPage from "../Pages/Chequered/ChequeredPage.tsx";
import ChequeredLandingPage from "../Pages/Chequered/ChequeredLandingPage.tsx";
import CollaborativeSessionPage from "../Pages/Chequered/CollaborativeSessionPage.tsx";
import PuzzleFullscreenPage from "../Pages/Chequered/PuzzleFullscreenPage.tsx";
import Campaigns from "../Pages/Growth/Campaigns.tsx";
import PageNotFound from "../Pages/ErrorPages/PageNotFound.tsx";
import SubscriptionPlanPage from "../Pages/Plans/SubscriptionPlanPage.tsx";
import SyllabusEditorPage from "../Pages/SyllabusEditor/SyllabusEditorPage.tsx";
import SlotsPage from "../Pages/Slots/SlotsPage.tsx";
import MarkupClassesPage from "../Pages/MarkupClasses/MarkupClassesPage.tsx";

import PaymentResult from "../Pages/payments/cashfree/PaymentResult.tsx";
import TransactionHistory from '../Pages/TransactionHistory/TransactionHistory.tsx';

import Offers from "../Pages/Offers/Offers.tsx"; // Add this import
// Screen size restriction removed - app now works on all screen sizes
import CashfreePayments from "../Pages/payments/cashfree/CashFreePayments.tsx";
import { ErrorBoundary } from "react-error-boundary";
import ExportHistory from "../Pages/ExportHistory/exportHistory.tsx";
import BulkRequestsPage from "../Pages/BulkRequests/BulkRequestsPage.tsx";
import PartnerPageComp from "../../PlundrComponents/Components/PartnerBanner.tsx";
import OffersEventsPage from "../Pages/Offers&Events/OffersEventsPage.tsx";
import EventDetailPage from "../Pages/Offers&Events/Components/EventDetailPage.tsx";
import OfferDetailPage from "../Pages/Offers&Events/Components/OfferDetailPage.tsx";
import AllSubscriptionsPage from "../Pages/AllSubscriptions/AllSubscriptionsPage.tsx";
import AttendanceSummary from "../Pages/AttendanceSummary/AttendanceSummary.tsx";
import Storefront from "../Pages/Storefront/Storefront.tsx";
import MyHome from "../Pages/MyDashboard.tsx";
import MyWorld from "../Pages/MyWorld/MyWorld.tsx";
import MySubscriptions from "../Pages/Home/MySubscriptions.tsx";
import Statistics from "../Pages/Statistics/Statistics.tsx";
import PartnerPageMinimal from "../../PlundrComponents/PartnerPageMinimal.tsx";
import Inflow from "../Pages/Inflow/Inflow.tsx";
import TeamManagement from "../Pages/TeamManagement/TeamManagement.tsx";
import Ledger from "../Pages/Ledger.tsx";
import SuperAdminDashboard from "../Pages/SuperAdmin/SuperAdminDashboard.tsx";
import MeetingPage from "../Pages/Meeting/MeetingPage.tsx";
import GuestJoin from "../Pages/MeetPlus/GuestJoin.tsx";
import MeetPlusAdvanced from "../Pages/SubscriptionDetails/MeetPlusAdvanced.tsx";
import { useMigrateUserData } from "../../../state/UserStatesV2/migrations.ts";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Provider } from "react-redux";
import { store } from "../../../state/state";
import AccessControl from "../Components/AccessControl.tsx";
import { PageName } from "../../../enums.ts";
import { Toaster } from 'react-hot-toast';


const ErrorFallback = ({ error }: { error: Error }) => (
    <div className="flex flex-col h-[100vh] w-[100vw] justify-center items-center">
        <div className="font-semibold mb-2">
            Something went wrong
        </div>
        <div className="max-w-72 text-sm text-center">
            {error.message}
        </div>
        <Link to="/mydashboard" className="text-cc_link text-sm underline font-semibold underline-offset-4 mt-2">
            Go Back
        </Link>
    </div>
);

export default function App() {
    useMigrateUserData();

    return (
        <BrowserRouter>
            <Provider store={store}>
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Toaster position="top-right" />
                        <div className={"h-screen w-screen"}>
                            <Routes>
                                <Route path="/" element={<PartnerPageMinimal />} />
                                <Route path="/meet/join" element={<GuestJoin />} />
                                <Route path="/join-meeting" element={<GuestJoin />} />
                                <Route path="/meeting" element={<MeetingPage />} />
                                <Route path="/fill-details" element={<FillDetails />} />
                                <Route path="/login" element={<Login />} />
                                {/* Collaborative session - no auth required for students */}
                                <Route path="/chequered/collaborative/:sessionId" element={<CollaborativeSessionPage />} />
                                {/* Puzzle fullscreen view */}
                                <Route path="/chequered/:subscriptionId/puzzle/:puzzleId" element={<PuzzleFullscreenPage />} />
                                {/*<Route path="/login" element={<Campaigns/>}/>*/}
                                <Route element={<Layout />}>
                                    <Route path="/mydashboard" element={<MyHome />} />
                                    <Route path="/myworld" element={<MyWorld />} />
                                    <Route path='/mysubscriptions/subscription/:Subscriptionid' element={<SubscriptionDetailsPage />} />
                                    <Route path='/mysubscriptions/subscription/:subscriptionid/meetplus-advanced' element={<MeetPlusAdvanced />} />
                                    <Route path="/chequered/:subscriptionId" element={<ChequeredLandingPage />} />
                                    <Route path="/chequered/:subscriptionId/puzzles" element={<ChequeredPage />} />
                                    <Route path="/chequered/:subscriptionId/teaching" element={<ChequeredPage />} />
                                    <Route path="/chequered/:subscriptionId/teaching/neo" element={<ChequeredPage />} />
                                    <Route path="/chequered/:subscriptionId/subscription-data" element={<ChequeredPage />} />
                                    <Route path="/chequered/:subscriptionId/analysis" element={<ChequeredPage />} />
                                    <Route path="/chequered/:subscriptionId/chess-basics" element={<ChequeredPage />} />
                                    <Route path="/mysubscriptions" element={<MySubscriptions />} />
                                    <Route path="/orders" element={<Orders />} />
                                    <Route path="/settings" element={<Profile />} />
                                    <Route path="/analytics" element={<Analytics />} />
                                    <Route path="/profile" element={<Profile />} />
                                    <Route path="/campaigns" element={<Campaigns />} />
                                    <Route path="/eventdetail/:eventId" element={<EventDetailPage />} />
                                    <Route path="/offerdetail/:offerId" element={<OfferDetailPage />} />
                                    <Route path="/paymentResult" element={<PaymentResult />} />
                                    <Route path="/paymentHistory" element={<TransactionHistory />} />
                                    <Route path="/offers" element={<Offers />} />
                                    <Route path="/exports" element={<ExportHistory />} />
                                    <Route path="/bulkrequests" element={<BulkRequestsPage />} />
                                    <Route path="/subscriptions" element={<AccessControl pageName={PageName.Subscription} restrictObserverOnly={true}><AllSubscriptionsPage /></AccessControl >} />
                                    <Route path="/events-offers" element={<OffersEventsPage />} />
                                    <Route path="/attendance-summary" element={<AttendanceSummary />} />
                                    <Route path="/storefront" element={<Storefront />} />
                                    <Route path="/statistics" element={<AccessControl pageName={PageName.Statistics} restrictObserverOnly={true}><Statistics /></AccessControl >} />
                                    <Route path="/ledger" element={<Ledger />} />
                                    <Route path="/inflow" element={<Inflow />} />
                                    <Route path="/team-management" element={<TeamManagement />} />
                                    <Route path="/superadmin" element={<SuperAdminDashboard />} />
                                    <Route path="/subscription-plan" element={<SubscriptionPlanPage />} />
                                    <Route path="/syllabus-editor/:syllabusId" element={<SyllabusEditorPage />} />
                                    <Route path="/create-syllabus" element={<SyllabusEditorPage isCreate={true} />} />
                                    <Route path="/slots" element={
                                        <AccessControl pageName={PageName.Subscription} restrictObserverOnly={true}>
                                            <SlotsPage />
                                        </AccessControl>
                                    } />
                                    <Route path="/slots/:Subscriptionid" element={
                                        <AccessControl pageName={PageName.Subscription} restrictObserverOnly={true}>
                                            <SlotsPage />
                                        </AccessControl>
                                    } />
                                    <Route path="/markup-classes" element={
                                        <AccessControl pageName={PageName.Subscription} restrictObserverOnly={true}>
                                            <MarkupClassesPage />
                                        </AccessControl>
                                    } />
                                </Route>

                                <Route path="/payments" element={
                                    <ErrorBoundary FallbackComponent={() => (
                                        <div className="flex flex-col h-[100vh] w-[100vw] justify-center items-center">
                                            <div className="font-semibold mb-2">
                                                Something went wrong
                                            </div>
                                            <div className="max-w-72 text-sm text-center">
                                                You might be having a network connection problem, the link might be expired, or the payment service provider cannot be reached at the moment.
                                            </div>
                                            <Link to="/mydashboard" className="text-cc_link text-sm underline font-semibold underline-offset-4 mt-2">
                                                Go Back
                                            </Link>
                                        </div>
                                    )}>
                                        <CashfreePayments />
                                    </ErrorBoundary>
                                } />
                                <Route path={"/myPage"} element={<PartnerPageComp />} />
                                <Route path={"*"} element={<PageNotFound />} />
                            </Routes>
                        </div>
                    </LocalizationProvider>
                </ErrorBoundary>
            </Provider>
        </BrowserRouter>
    );
}